import { $, $all } from "@olmokit/dom";
// import  { breakpoints, gridGutter } from "@acanto/frontend/scss";
import { glide, LazyLoad, Swipe } from "@olmokit/core/glide";
import "./mosaics.scss";

export default function dialogProductMosaics($root) {
  const $container = $(".Productdialog:mosaics__list", $root);
  if (!$container) {
    return;
  }
  const slidesCount = $all(".glide__slide", $container).length;
  const getSliderPerView = () => {
    return $container.offsetWidth / 200;
  };
  const responsiveCheck = () => {
    const perView = getSliderPerView();
    slider.update({ perView });

    if (slidesCount < perView) {
      slider.disable();
      $container.classList.remove("glide--swipeable");
    } else {
      slider.enable();
      $container.classList.add("glide--swipeable");
    }
    // slider.go("<<");
  };
  const slider = glide($container, {
    loop: false,
    bound: true,
    perView: getSliderPerView(),
  })
    .on("resize", responsiveCheck)
    .mount({ LazyLoad, Swipe });

  responsiveCheck();

  return slider;
}
